import styled from 'styled-components';
import { Form } from 'antd';
import { LoadingImage } from './Loading';

export const CustomFormItem = styled(Form.Item)`
  // padding-bottom: 6px;

  .ant-form-item-label {
    padding: 0;
  }

  .ant-form-item-label > label {
    height: 22px;
    margin: 0 0 12px 0;
    width: 100%;
    font-size: 16px;
    font-weight: 500;
    font-stretch: normal;
    font-style: normal;
    line-height: normal;
    letter-spacing: normal;
    color: #162056;
    font-family: UbuntuMedium, sans-serif;

    .ant-form-item-required-mark {
      display: none;
    }

    &::before {
      display: none !important;
    }

    &::after {
      content: ' *:' !important;
      display: inline-block;
      color: #162056;
      
      background: linear-gradient(to right, #ff4d4f 0%, #ff4d4f 60%, #162056 60%, #162056 100%);
      -webkit-background-clip: text;
      -webkit-text-fill-color: transparent;
      background-clip: text;
    }
  }

  .ant-form-item-label > label:not(.ant-form-item-required)::after {
    content: '' !important;
    color: #162056;
    background: none;
    -webkit-text-fill-color: #162056;
  }
`;

export const CustomFormItemConstantWidth = styled(Form.Item)`
  // padding-bottom: 6px;

  .ant-form-item-label {
    padding: 0;
  }

  .ant-form-item-control-input-content {
    width: 14vw !important;
  }
  .ant-form-item-control-input-control {
    width: 14vw !important;
  }

  .ant-form-item-label > label {
    height: 22px;
    margin: 0 0 12px 0;
    width: 100%;
    font-size: 16px;
    font-weight: 500;
    font-stretch: normal;
    font-style: normal;
    line-height: normal;
    letter-spacing: normal;
    color: #162056;
    font-family: UbuntuMedium, sans-serif;
  }
`;

const CustomForms = styled(Form)`
  .ant-form-vertical .ant-form-item-label,
  .ant-col-24.ant-form-item-label,
  .ant-col-xl-24.ant-form-item-label {
    padding: 0;
  }
`;

const CustomForm = (props) => {
  const { awaitLoading, ...preProps } = props;
  return awaitLoading ? <LoadingImage /> : <CustomForms {...preProps} />;
};

export default CustomForm;
